/** Presentation proof, populated only after exact owned saved-slot reconciliation.
 * A saved-image receipt does not change the scheduler or accounting status. */
export function verifiedSavedGenerationSummary(value: unknown): string | undefined {
 const r=value as any;
 if(r?.savedGenerationVerified!==true||r.deliveryUnverified===true||!Number.isSafeInteger(r.workflowRunId)||r.workflowRunId<1
  ||!Number.isSafeInteger(r.requestedCount)||r.requestedCount<1||r.requestedCount>500
  ||r.deliveredCount!==r.requestedCount||r.failedCount!==0||!Array.isArray(r.generated)||r.generated.length!==r.deliveredCount
  ||!['completed','pending'].includes(r.accountingStatus))return;
 const ids=new Set<string>();
 for(const image of r.generated){
  if(typeof image?.id!=='string'||!image.id||ids.has(image.id)||typeof image.imageUrl!=='string'||!/^https?:\/\//.test(image.imageUrl)
   ||(image.qaPassed!==undefined&&typeof image.qaPassed!=='boolean'))return;
  ids.add(image.id);
 }
 const passed=r.generated.filter((i:any)=>i.qaPassed===true).length,review=r.generated.filter((i:any)=>i.qaPassed===false).length;
 const unknown=r.generated.length-passed-review;
 if(r.qaPassedCount!==passed||r.qaFailedCount!==review||r.qaUnavailableCount!==unknown)return;
 return `${r.deliveredCount} of ${r.requestedCount} requested images are saved on your canvas. ${passed} passed quality review; ${review} need${review===1?'s':''} review; ${unknown} ${unknown===1?'is':'are'} not quality-verified.`
  +(r.accountingStatus==='pending'?' Credit settlement is still pending.':'')
  +(r.deliveryWarning?' Follow-up processing could not finish; the recorded error remains below. Saved images have not been run again.':'');
}
